import type { Accept } from 'react-dropzone'

export const MAX_FILES = 6
export const MAX_FILE_SIZE = 15 * 1024 * 1024

export const IMAGES_MIME: Accept = {
  'image/*': ['.jpg', '.jpeg', '.png', '.gif', '.webp'],
}

export const VIDEOS_MIME: Accept = {
  'video/*': ['.mp4', '.mov', '.avi', '.mkv', '.webm'],
}

export const AUDIO_MIME: Accept = {
  'audio/*': ['.mp3', '.wav', '.ogg', '.m4a'],
}

export const DOCUMENTS_MIME: Accept = {
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc', '.docx'],
  'application/vnd.ms-excel': ['.xls', '.xlsx'],
  'application/vnd.ms-powerpoint': ['.ppt', '.pptx'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    '.docx',
  ],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
    '.pptx',
  ],
  'text/plain': ['.txt'],
}

export const ACCEPTED_MIME: Accept = {
  ...IMAGES_MIME,
  ...VIDEOS_MIME,
  ...AUDIO_MIME,
  ...DOCUMENTS_MIME,
}
